import PropTypes from 'prop-types';

export default {
  citesYourPaper: 'CitesYourPaper',
  citesYourCitation: 'CitesYourCitation',
  citesCoAuthor: 'CitesCoAuthor',
  citesYourCiter: 'CitesYourCiter',
};

const citesShape = {
  eid: PropTypes.string,
  firstname: PropTypes.arrayOf(PropTypes.string),
  itemtitle: PropTypes.arrayOf(PropTypes.string),
  lastname: PropTypes.arrayOf(PropTypes.string),
  pgfirst: PropTypes.string,
  pglast: PropTypes.string,
  pubdatetxt: PropTypes.string,
  srctitle: PropTypes.string,
};

export const connectionsPropTypes = {
  CitesYourPaper: PropTypes.arrayOf(PropTypes.shape(citesShape)),
  CitesYourCitation: PropTypes.arrayOf(PropTypes.shape(citesShape)),
  CitesCoAuthor: PropTypes.arrayOf(PropTypes.shape(citesShape)),
  CitesYourCiter: PropTypes.arrayOf(PropTypes.shape(citesShape)),
};
